import { motion } from 'framer-motion'
import React, { ReactNode } from 'react'
import {
  animationAppTransitions,
  animationAppVariants
} from '../../Helpers/pageAnimation'
import { useProfileStyles } from './styles'

interface LayoutProps {
  children?: ReactNode
}

const ProfileLayout = ({ children }: LayoutProps): JSX.Element => {
  const classes = useProfileStyles()
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={animationAppVariants}
      transition={animationAppTransitions}
      className={classes.root}
    >
      <div className={classes.list}>{children}</div>
    </motion.div>
  )
}

export default ProfileLayout
